import { styled } from '@mui/material/styles';

/**
 * Wraps one clickable child and rings it in the brand color while selected or
 * keyboard-focused. The ring sits on the child so it follows the child's own radius.
 */
export const SelectionOutline = styled('div', {
  shouldForwardProp: prop => prop !== 'selected',
})<{ selected: boolean }>(({ theme, selected }) => ({
  '& > *': {
    cursor: 'pointer',
    outline: selected ? '3px solid' : 'none',
    outlineColor: theme.palette.primary.main,
    outlineOffset: 2,
  },
  '& > *:focus-visible': {
    outline: '3px solid',
    outlineColor: theme.palette.primary.main,
    outlineOffset: 2,
  },
}));
